import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router';
import './Login.css'; // Reuse the same styles as Login
import api from '../services/api';

const ResetPassword = () => {
  const [searchParams] = useSearchParams(); // Get query parameters
  const resetToken = searchParams.get('code'); // Extract the 'code' parameter
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      const response = await api.resetPassword(resetToken, password, confirmPassword);

      const data = await response.json();

      if (data.user) {
        setMessage('Password reset successfully! Redirecting to login...');
        setTimeout(() => navigate('/'), 3000); // Redirect to login after 3 seconds
      } else {
        throw new Error(data.error.message || 'Failed to reset password');
      }
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="logo">
          <img src="/assets/loginassets/COLA_interface_LogIn_LOGO-03.svg" alt="COLA Logo" />
        </div>

        {error && <div className="error-message">{error}</div>}
        {message && <div className="success-message">{message}</div>}
        
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">New Password</label>
            <input
              type="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label className="form-label">Confirm New Password</label>
            <input
              type="password"
              className="form-input"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          
          <button type="submit" className="login-button">Reset Password</button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword; 